<template>
  <el-container>
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
        <el-row>
          <el-col :span="4">
            <el-form-item label="机构" prop="organization" class="cls-col">
              <el-select v-model="searchData.orgCode" clearable placeholder="所属机构" size="small" style="width: 100%"
                         @change="changeOrg">
                <el-option
                    v-for="item in organizationData"
                    :key="item.organizationName"
                    :label="item.organizationName"
                    :value="item.orgCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="所属分类" :inline="true" prop="ccId" >
              <el-cascader
                  expand-trigger="hover"
                  :options="commoditys"
                  clearable
                  style="width: 100%"
                  size="small"
                  :props="{ value: 'ccId', label: 'ccName',children: 'children'}"
                  v-model="searchData.ccId"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="新闻类别" prop="categoryId" >
              <el-select v-model="searchData.categoryId" clearable placeholder="新闻类别" size="small" style="width: 100%">
                <el-option
                    v-for="item in categoryData"
                    :key="item.categoryName"
                    :label="item.categoryName"
                    :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态" prop="status" class="cls-col">
              <el-select v-model="searchData.status" clearable placeholder="状态" size="small" style="width: 100%">
                <el-option label="置顶+最新" :value="1"></el-option>
                <el-option label="置顶" :value="2"></el-option>
                <el-option label="最新" :value="3"></el-option>
                <el-option label="普通" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="标题" prop="title" class="cls-col">
              <el-input v-model="searchData.title" placeholder="内容" size="small" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
        </el-form-item>
      
      </el-form>
      <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addNews" class="but-cls">
        添加
      </el-button>
      <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteNewsMore" class="but-cls">删除
      </el-button>
      <el-table
          :data="commodityData"
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          style="width: 100%">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="50"
            fixed="left"
        >
        </el-table-column>
        <el-table-column
            prop="title"
            fixed
            label="新闻标题"
        >
        </el-table-column>
        <el-table-column
            prop="categoryName"
            label="新闻类别"
        >
        </el-table-column>
        <el-table-column
            prop="ccName2"
            label="所属分类"
            :formatter="f_ccName"
        >
        </el-table-column>
        <el-table-column
            prop="organizationName"
            label="所属机构"
        >
        </el-table-column>
        <el-table-column
            prop="author"
            label="作者"
        >
        </el-table-column>
        <el-table-column
            prop="clicks"
            label="点击量"
        >
        </el-table-column>
        <el-table-column
            prop="status"
            :formatter="f_status"
            label="状态"
        >
        </el-table-column>
        <el-table-column
            prop="isShow"
            :formatter="show_status"
            label="是否显示"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间"
            :formatter="dateFormat"
            width="200"
        >
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateNews(scope.row)">编辑</el-button>
            <el-button @click="deleteNews(scope.$index, scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="showNews(scope.row)" type="text" size="small">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat, monthFormat} from '@/api/utils.js';

  const formData = {};
  export default {
    data() {
      return {
        formData: JSON.parse(JSON.stringify(formData)),
        commodityData: [],
        href: '',
        searchData: {
          size: 0,
          page: 1,
          title: '',
          categoryId: '',
          ccId2: '',
          ccId: '',
          status: '',
          createTimeStart: '',
          createTimeEnd: '',
          orgCode: ''
        },
        categoryData: [],
        commoditys: [],
        ccId2Data: [],
        organizationData: [],
        showEdit: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        courseOptions: [],
        
      };
    },
    methods: {
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      f_status(row, column, cellValue, index) {
        if (cellValue == '1') {
          return '置顶+最新';
        }
        else if (cellValue == '2') {
          return '置顶';
        }
        else if (cellValue == '3') {
          return '最新';
        }
        else if (cellValue == '4') {
          return '普通';
        }
        return '';
      },
      show_status(row, column, cellValue, index) {
        if (cellValue == '1') {
          return '显示';
        }else{
          return '隐藏';
        }
      },
      handleEdit(index, row) {
        this.showEdit[row.commodityId] = true;
        this.search();
      },
      addNews() {
        this.$router.push({
          name: 'addnews',
          params: {'title': '添加新闻'}
        });
      },
      dateFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].newsId;
        }
      },
      updateNews(row) {
        this.$router.push({
          name: 'addnews',
          params: row
        });
      },
      showNews(row) {
        let params = {
          newsId: row.newsId
        };
        https.fetchPost(https.newsURL + '?newsId=' + row.newsId, params, 'json').then((data) => {
           var url = data.data.split("*")[1];
           window.open(url, '_blank');
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
      },
      deleteNewsMore() {
        let length = this.multipleSelection.length;
        this.$confirm('此操作将删除' + length + '条新闻, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          let params = {'newsIdList': multipleSelection};
          https.fetchPost('/webNews/deleteNews', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteNews(index, row) {
        //deleteIsRecommendByCommodityId
        this.$confirm('此操作将删除该新闻, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {'newsIdList': []};
          params.newsIdList.push(row.newsId);
          https.fetchPost('/webNews/deleteNews', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      monthFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return monthFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = 10;
        let params = this.searchData;
        if(params.ccId instanceof Array) {
          if(params.ccId.length > 0) {
            params.ccId1 = params.ccId[0];
            params.ccId2 = params.ccId[1];
          }
        }
        https.fetchPost('/webNews/list', params, 'json').then((data) => {
          console.log(data);
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.commodityData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
      loadNewsCategory() {
        this.categoryData = [];
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        https.fetchPost('/webNewsCategory/selectCategoryTree', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            if(data.data.data) {
              this.categoryData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      searchCourseType() {
        this.commoditys = [];
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if(data.data.data) {
              for(let commodity of data.data.data) {
                if(commodity.children) {
                  for(let child of commodity.children) {
                    if(child.children) {
                      child.children = null;
                    }
                  }
                  this.commoditys.push(commodity);
                }
              }
            }

          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      changeOrg() {
        this.searchCourseType();
        this.searchData.ccId = '';
        this.loadNewsCategory();
        this.searchData.categoryId = "";
      },
      f_ccName(row, column, cellValue, index) {
        if(row.ccName1 && row.ccName2) {
          return row.ccName1+"/"+row.ccName2;
        }
        return "";
      },
      loadOrganization() {
        let params = {};
        https.fetchGet('/managerOrganization/getOrganizationList', params, 'from').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            let d = data.data.data;
            if(data.data.data) {
              this.organizationData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      changeCourse(val) {
        //this.searchData.categoryId = '';
      }
    },
    created: function() {
      this.searchData.orgCode = this.$store.state.orgCode;
      this.searchCourseType();
      this.loadNewsCategory();
      this.loadOrganization();
      this.search();
    }
  };
</script>

<style scoped>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .line {
    text-align: center;
  }
  
  .edit-cell {
    width: 60%;
  }
  
  .cls-col {
    margin-right: 20px;
  }
  
  .target {
    margin-left: 10px;
    color: #409EFF;
  }
</style>
